import MuiLink from '@mui/material/Link';
import { styled } from '@mui/material/styles';

export const StyledForbiddenPracticesLink = styled(MuiLink)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-6),
  right: theme.spacing(18),
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: 1.5,
  '&:hover': {
    opacity: 0.8,
  },
  // Hide on mobile
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
